<div class="container-fluid admin-page vouchers-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Vouchers' | translate }}</h1>
            <p>{{ 'Pending voucher payments waiting for review.' | translate }}</p>
        </div>
        <div class="admin-header-actions">
            <button (click)="loadPendingVouchers()" [disabled]="isLoadingVouchers"
                    class="admin-refresh-button" type="button">
                <i class="material-icons">refresh</i><span>{{ 'Refresh' | translate }}</span>
            </button>
        </div>
    </header>

    <div class="admin-toolbar">
        <label class="admin-search-field">
            <span>{{ 'Search vouchers' | translate }}</span>
            <div class="admin-search-input">
                <i class="material-icons">search</i>
                <input (ngModelChange)="onSearchTextChanged($event)" [disabled]="isLoadingVouchers"
                       [ngModel]="searchText" [placeholder]="'Search by client name, voucher ID or amount' | translate"
                       type="search">
            </div>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Car ID' | translate }}</span>
            <select (ngModelChange)="onCarFilterChanged($event)" [disabled]="isLoadingVouchers"
                    [ngModel]="carFilter">
                <option value="">{{ 'All cars' | translate }}</option>
                <option *ngFor="let carId of getCarFilterOptions()" [value]="carId">{{ carId }}</option>
            </select>
        </label>
        <label class="admin-filter-field">
            <span>{{ 'Client name' | translate }}</span>
            <select (ngModelChange)="onClientFilterChanged($event)" [disabled]="isLoadingVouchers"
                    [ngModel]="clientFilter">
                <option value="">{{ 'All clients' | translate }}</option>
                <option *ngFor="let client of getClientFilterOptions()" [value]="client">{{ client }}</option>
            </select>
        </label>
        <label class="admin-page-size">
            <span>{{ 'Rows' | translate }}</span>
            <select (ngModelChange)="changePageSize()" [(ngModel)]="pageSize" [disabled]="isLoadingVouchers">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
            </select>
        </label>
    </div>

    <div *ngIf="isLoadingVouchers" class="loading-state admin-page-state">
        <div class="loading-spinner"></div>
        <span>{{ 'Loading vouchers...' | translate }}</span>
    </div>

    <ng-container *ngIf="!isLoadingVouchers">
        <div *ngIf="filteredVouchers.length > 0" class="vouchers-table-wrap admin-data-table-wrap">
            <table class="vouchers-table admin-data-table">
                <thead>
                <tr>
                    <th [attr.aria-sort]="tableSort.getAriaSort('created')">
                        <button (click)="tableSort.toggle('created')" class="admin-sort-button" type="button">
                            <span>{{ 'Created' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('created', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('created', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('client')">
                        <button (click)="tableSort.toggle('client')" class="admin-sort-button" type="button">
                            <span>{{ 'Client' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('client', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('client', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('voucher')">
                        <button (click)="tableSort.toggle('voucher')" class="admin-sort-button" type="button">
                            <span>{{ 'Voucher ID' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('voucher', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('voucher', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('amount')">
                        <button (click)="tableSort.toggle('amount')" class="admin-sort-button" type="button">
                            <span>{{ 'Amount' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('amount', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('amount', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('car')">
                        <button (click)="tableSort.toggle('car')" class="admin-sort-button" type="button">
                            <span>{{ 'Car ID' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('car', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('car', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('order')">
                        <button (click)="tableSort.toggle('order')" class="admin-sort-button" type="button">
                            <span>{{ 'Order' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('order', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('order', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let voucher of getPagedVouchers()">
                    <td [attr.data-label]="'Created' | translate">{{ voucher.CreatedAt | date:'dd.MM.yyyy HH:mm' }}</td>
                    <td [attr.data-label]="'Client' | translate">{{ voucher.ClientName || '-' }}</td>
                    <td [attr.data-label]="'Voucher ID' | translate">{{ voucher.VoucherId || '-' }}</td>
                    <td [attr.data-label]="'Amount' | translate">{{ getAmount(voucher.Amount) }} lei</td>
                    <td [attr.data-label]="'Car ID' | translate">{{ voucher.CarIdentifier || '-' }}</td>
                    <td [attr.data-label]="'Order' | translate">
                        <strong [class.has-order]="hasOrder(voucher)" class="order-status-pill">
                            {{ (hasOrder(voucher) ? 'YES' : 'NO') | translate }}
                        </strong>
                    </td>
                    <td class="voucher-actions">
                        <button (click)="openDetails(voucher)" class="details-button" type="button">
                            {{ 'Details' | translate }}
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="filteredVouchers.length === 0" class="empty-state admin-page-state">
            <i class="material-icons">receipt</i>
            <span>{{
                    (
                    pendingVouchers.length === 0
                        ? 'No pending vouchers.'
                        : 'No vouchers match the current search or filters.'
                    ) | translate
                }}</span>
        </div>

        <footer *ngIf="filteredVouchers.length > 0" class="admin-pagination">
            <span class="admin-pagination-summary">
                {{ 'Showing' | translate }} {{ getFirstItemNumber() }}-{{ getLastItemNumber() }}
                {{ 'of' | translate }} {{ filteredVouchers.length }} {{ 'vouchers' | translate }}
            </span>
            <div class="admin-pagination-buttons">
                <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
                        [attr.aria-label]="'Previous page' | translate" type="button">
                    <i class="material-icons">chevron_left</i>
                </button>
                <button (click)="goToPage(page)" *ngFor="let page of getVisiblePages()"
                        [attr.aria-current]="page === currentPage ? 'page' : null"
                        [class.active]="page === currentPage" type="button">{{ page }}
                </button>
                <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === getTotalPages()"
                        [attr.aria-label]="'Next page' | translate" type="button">
                    <i class="material-icons">chevron_right</i>
                </button>
            </div>
        </footer>
    </ng-container>
</div>

<div (click)="closeDetails()" *ngIf="selectedVoucher" class="voucher-modal-backdrop">
    <div (click)="$event.stopPropagation()" class="voucher-modal">
        <div class="voucher-modal-header">
            <div>
                <span>{{ 'Voucher details' | translate }}</span>
                <strong>{{ selectedVoucher.ClientName || selectedVoucher.OrderIdentifier || selectedVoucher.Id || '-' }}</strong>
            </div>
            <button (click)="closeDetails()" [disabled]="isPayingVoucher" [title]="'Close' | translate"
                    class="modal-close"
                    type="button">
                <i class="material-icons">close</i>
            </button>
        </div>

        <div class="voucher-tabs">
            <button (click)="setVoucherTab('payment')" [class.active]="isVoucherTabActive('payment')" type="button">
                {{ 'Payment' | translate }}
            </button>
            <button (click)="setVoucherTab('order')"
                    *ngIf="selectedVoucherOrderWrapper"
                    [class.active]="isVoucherTabActive('order')"
                    type="button">
                {{ 'Order' | translate }}
            </button>
        </div>

        <div [class.single-panel]="!isVoucherTabActive('payment')" class="voucher-modal-body">
            <section *ngIf="isVoucherTabActive('payment')" class="voucher-details-panel">
                <h3>{{ 'Payment' | translate }}</h3>
                <div class="details-grid">
                    <div>
                        <span>{{ 'Amount' | translate }}</span>
                        <label class="editable-value">
                            <input [(ngModel)]="selectedVoucher.Amount"
                                   [disabled]="isPayingVoucher"
                                   min="0"
                                   step="0.01"
                                   type="number">
                            <small>lei</small>
                        </label>
                    </div>
                    <div>
                        <span>{{ 'Voucher amount' | translate }}</span>
                        <strong>{{ getAmount(selectedVoucher.VoucherAmount) }} lei</strong>
                    </div>
                    <div *ngIf="shouldEditVoucherId()">
                        <span>{{ 'Voucher ID' | translate }}</span>
                        <input [(ngModel)]="selectedVoucher.VoucherId"
                               [disabled]="isPayingVoucher"
                               class="editable-input"
                               type="text">
                    </div>
                    <div>
                        <span>{{ 'Created' | translate }}</span>
                        <strong>{{ selectedVoucher.CreatedAt | date:'dd.MM.yyyy HH:mm' }}</strong>
                    </div>
                    <div>
                        <span>{{ 'Order' | translate }}</span>
                        <strong>{{ selectedVoucher.OrderIdentifier || '-' }}</strong>
                    </div>
                    <div>
                        <span>{{ 'Car' | translate }}</span>
                        <strong>{{ selectedVoucher.CarIdentifier || '-' }}</strong>
                    </div>
                    <div class="details-wide">
                        <span>{{ 'Client' | translate }}</span>
                        <strong>{{ selectedVoucher.ClientName || '-' }}</strong>
                    </div>
                    <div class="details-wide">
                        <span>{{ 'Destination' | translate }}</span>
                        <strong>{{ selectedVoucher.Destination || '-' }}</strong>
                    </div>
                    <div *ngIf="shouldEditVoucherIds()" class="details-wide">
                        <span>{{ 'Voucher IDs' | translate }}</span>
                        <textarea [(ngModel)]="editableVoucherIds"
                                  [disabled]="isPayingVoucher"
                                  class="editable-input editable-textarea"
                                  rows="3"></textarea>
                    </div>
                </div>

                <div *ngIf="payMessage && isPayMessageError()" class="action-message error modal-message">
                    <i class="material-icons">error</i>
                    <span>{{ payMessage | translate }}</span>
                </div>

                <div class="modal-actions">
                    <button (click)="payVoucher(selectedVoucher)" [disabled]="isPayingVoucher" class="pay-button"
                            type="button">
                        <i class="material-icons">payments</i>
                        <span>{{ (isPayingVoucher ? 'Paying...' : 'Pay voucher') | translate }}</span>
                    </button>
                </div>
            </section>

            <section *ngIf="isVoucherTabActive('payment')" class="voucher-photo-panel">
                <div class="photo-toolbar">
                    <h3>{{ 'Photo' | translate }}</h3>
                    <div class="zoom-controls">
                        <button (click)="zoomOut()" [disabled]="imageZoom <= 0.5" [title]="'Zoom out' | translate"
                                type="button">
                            <i class="material-icons">remove</i>
                        </button>
                        <button (click)="resetZoom()" [title]="'Reset zoom' | translate" type="button">
                            {{ imageZoom * 100 | number:'1.0-0' }}%
                        </button>
                        <button (click)="zoomIn()" [disabled]="imageZoom >= 3" [title]="'Zoom in' | translate"
                                type="button">
                            <i class="material-icons">add</i>
                        </button>
                    </div>
                </div>

                <div #photoViewer
                     (mousedown)="startPhotoDrag($event, photoViewer)"
                     (mouseleave)="stopPhotoDrag()"
                     (mousemove)="movePhotoDrag($event, photoViewer)"
                     *ngIf="hasVoucherImage(selectedVoucher)"
                     [class.dragging]="isDraggingPhoto"
                     class="photo-viewer">
                    <img [alt]="selectedVoucher.FileName || ('Voucher photo' | translate)"
                         [src]="getVoucherImageUrl(selectedVoucher)"
                         [style.width.%]="imageZoom * 100"
                         draggable="false">
                </div>

                <div *ngIf="!hasVoucherImage(selectedVoucher)" class="photo-empty">
                    <i class="material-icons">image_not_supported</i>
                    <span>{{ 'No photo attached.' | translate }}</span>
                </div>
            </section>

            <section *ngIf="isVoucherTabActive('order') && selectedVoucherOrderWrapper" class="voucher-order-panel">
                <div class="order-tab-grid">
                    <div class="order-left-column">
                        <section class="order-details-panel">
                            <h3>{{ 'Summary' | translate }}</h3>
                            <div class="details-grid">
                                <div>
                                    <span>{{ 'Order' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.identifier }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Status' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.state | translate }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Started' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.started | date:'dd.MM.yyyy HH:mm' }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Finished at' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.finished | date:'dd.MM.yyyy HH:mm' }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Platform' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.platform | translate }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Customer' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.customer }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Assigned car' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.assignedCar }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Car number' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.carNumber }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Driver' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.driverName }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Driver phone' | translate }}</span>
                                    <div *ngIf="selectedOrderSummary.driverPhone !== '-'" class="order-phone-line">
                                        <strong>{{ selectedOrderSummary.driverPhone }}</strong>
                                        <a [href]="'tel:' + selectedOrderSummary.driverPhone"
                                           class="call-button"
                                           [title]="'Call driver' | translate">
                                            <i class="material-icons">phone</i>
                                        </a>
                                    </div>
                                    <strong *ngIf="selectedOrderSummary.driverPhone === '-'">-</strong>
                                </div>
                                <div>
                                    <span>{{ 'Price' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.price }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'Distance' | translate }}</span>
                                    <strong>{{ selectedOrderSummary.distance }}</strong>
                                </div>
                            </div>
                        </section>

                        <section class="order-details-panel">
                            <h3>{{ 'Route' | translate }}</h3>
                            <div class="route-details">
                                <div *ngFor="let point of selectedOrderRoutePoints"
                                     [class.route-point-destination]="point.type === 'destination'"
                                     [class.route-point-pickup]="point.type === 'pickup'"
                                     [class.route-point-stop]="point.type === 'stop'"
                                     class="route-point">
                                    <span>{{ point.label | translate }}</span>
                                    <strong>{{ point.formattedAddress }}</strong>
                                </div>
                            </div>
                        </section>
                    </div>

                    <section class="order-details-panel map-panel">
                        <h3>{{ 'Map' | translate }}</h3>
                        <div *ngIf="selectedOrderMapMarkers.length > 0" class="order-map">
                            <google-map #voucherOrderMap (idle)="fitSelectedOrderMapBounds()"
                                        [center]="selectedOrderMapCenter" [zoom]="selectedOrderMapZoom"
                                        height="100%" width="100%">
                                <map-marker #voucherMapMarker
                                            (mapClick)="openSelectedOrderMapInfo(voucherMapMarker, marker)"
                                            *ngFor="let marker of selectedOrderMapMarkers"
                                            [label]="marker.labelOptions"
                                            [options]="marker.options"
                                            [position]="marker.position">
                                </map-marker>
                                <map-info-window #voucherInfoWindow>
                                    <strong *ngIf="selectedOrderInfoMarker">
                                        {{ selectedOrderInfoMarker.title | translate }}
                                    </strong>
                                </map-info-window>
                            </google-map>
                        </div>
                        <div *ngIf="selectedOrderMapMarkers.length === 0" class="photo-empty">
                            <i class="material-icons">location_off</i>
                            <span>{{ 'No route coordinates available.' | translate }}</span>
                        </div>
                    </section>
                </div>
            </section>
        </div>
    </div>
</div>
